import React from 'react';

export const SkeletonCard = () => (
  <div className="bg-white shadow rounded-lg p-6 animate-pulse">
    <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
    <div className="h-7 w-32 bg-gray-300 rounded" />
  </div>
);
